import { SectionTitle } from '../../ui';
import { LocationCard } from './LocationCard';
import { locations, companyInfo } from '../../../data';

export function Locations() {
    return (
        <section className="py-12 md:py-16 bg-blue-900">
            <div className="container mx-auto px-4 max-w-[1240px]">
                <SectionTitle subtitle="Ne gasiti in doua locatii in Botosani" className="text-white [&>h2]:text-white [&>p]:text-white/80">Unde ne gasiti?</SectionTitle>

                {/* Company Address Info */}
                <p className="text-center text-white/80 font-font-s mb-8 max-w-2xl mx-auto">
                    {companyInfo.name} are sediul social in Municipiul Botosani, {companyInfo.address.street}, Cod
                    postal {companyInfo.address.postalCode}, {companyInfo.address.county}.
                </p>

                {/* Location Cards Grid */}
                <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
                    {locations.map((location) => (
                        <LocationCard key={location.id} location={location} />
                    ))}
                </div>
            </div>
        </section>
    );
}
